import React from "react";
import { Check, Cable, Cpu, Thermometer, Network, Download } from "lucide-react";
import { IMG, BOX_FEATURES } from "@/lib/content";

const highlights = [
  { icon: Cpu, label: "barox PoE-Switch" },
  { icon: Network, label: "Glasfaser ready" },
  { icon: Thermometer, label: "Aktive Entlüftung" },
  { icon: Cable, label: "Bis zu 4 IP-Kameras" },
];

export default function JunctionBox() {
  return (
    <section
      id="anschlusskasten"
      data-testid="box-section"
      className="relative bg-slate-50 py-24 md:py-32"
    >
      <div className="absolute inset-0 bg-grid opacity-50 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          <div className="lg:col-span-6 order-2 lg:order-1">
            <div className="relative rounded-2xl overflow-hidden border border-slate-200 bg-gradient-to-br from-slate-50 to-white shadow-sm p-6 md:p-10 flex items-center justify-center">
              <img
                src={IMG.junctionBox}
                alt="Xortec Kameraanschlusskasten – Edelstahl, geöffnet mit Überspannungsschutz, Glasfaser-Spleißbox und PoE-Switch"
                className="w-full h-auto max-h-[640px] object-contain"
              />
            </div>
            <div className="mt-6 grid grid-cols-2 sm:grid-cols-4 gap-3">
              {highlights.map((h) => (
                <div
                  key={h.label}
                  className="bg-white border border-slate-200 rounded-lg p-4 flex flex-col items-start gap-2"
                >
                  <span className="inline-flex h-8 w-8 items-center justify-center rounded-md bg-[#0055A4]/10 text-[#0055A4]">
                    <h.icon className="h-4 w-4" />
                  </span>
                  <span className="text-xs font-medium text-slate-700">
                    {h.label}
                  </span>
                </div>
              ))}
            </div>
            <div className="mt-5 flex justify-center">
              <a
                href="https://products.barox.ch/?pdf=lt-lpite-402gbtme"
                target="_blank"
                rel="noreferrer"
                data-testid="box-switch-datenblatt-button"
                className="inline-flex items-center justify-center gap-2 bg-white text-[#0055A4] hover:bg-[#0055A4] hover:text-white border border-[#0055A4] px-5 py-2.5 rounded-md text-sm font-medium transition-colors"
              >
                <Download className="h-4 w-4" />
                Datenblatt Switch
              </a>
            </div>
          </div>

          <div className="lg:col-span-6 order-1 lg:order-2">
            <p className="tag-line text-xs font-mono-tech uppercase tracking-[0.25em] text-[#0055A4] mb-6">
              Produkt · Kameraanschlusskasten
            </p>
            <h2
              data-testid="box-headline"
              className="font-display text-3xl sm:text-4xl lg:text-5xl font-semibold text-slate-900 tracking-tight"
            >
              Die intelligente Schnittstelle{" "}
              <span className="text-slate-500">
                zwischen Kamera, Stromversorgung und Netzwerk.
              </span>
            </h2>
            <p className="mt-6 text-slate-600 text-base sm:text-lg leading-relaxed">
              Robust gebaut, aktiv belüftet und mit allen Komponenten für eine
              professionelle CCTV-Installation – der Xortec Kameraanschlusskasten
              ist das technische Herz unserer Gesamtlösung.
            </p>

            <ul className="mt-10 space-y-3">
              {BOX_FEATURES.map((f, i) => (
                <li
                  key={f}
                  data-testid={`box-feature-${i}`}
                  className="flex items-start gap-3"
                >
                  <span className="mt-1 inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[#0055A4]/10 text-[#0055A4]">
                    <Check className="h-3 w-3" strokeWidth={3} />
                  </span>
                  <span className="text-slate-700 text-sm leading-relaxed">
                    {f}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
